<div class="block">
  <h4>Add conditions:</h4>

  <ng-container *ngIf="conditions$ | async as conditions">

    <div class="condition-group">
      <h5>Major Conditions (Select up to 3)</h5>
      <div class="conditions">
        <ion-item class="item ion-no-padding" *ngFor="let condition of conditions.major" lines="none">
          <ion-checkbox [(ngModel)]="condition.checked" (ionChange)="addCondition(condition, conditions)"
            [disabled]="condition.disabled && !condition.checked"></ion-checkbox>
          <ion-label>{{condition.group}}</ion-label>
        </ion-item>
      </div>
    </div>

    <div class="condition-group">
      <h5>Partial Cancer (Select 1)</h5>
      <div class="conditions">
        <ion-item class="item ion-no-padding" *ngFor="let condition of conditions.cancer" lines="none">
          <ion-checkbox [(ngModel)]="condition.checked" (ionChange)="addCondition(condition, conditions)"
            [disabled]="condition.disabled && !condition.checked"></ion-checkbox>
          <ion-label>{{condition.group}}</ion-label>
        </ion-item>
      </div>
    </div>

    <div class="condition-group">
      <h5>Additional Covers (Select up to 3)</h5>
      <div class="conditions">
        <ion-item class="item ion-no-padding" *ngFor="let condition of conditions.other" lines="none">
          <ion-checkbox [(ngModel)]="condition.checked" (ionChange)="addCondition(condition, conditions)"
            [disabled]="condition.disabled && !condition.checked"></ion-checkbox>
          <ion-label>{{condition.group}}</ion-label>
        </ion-item>
      </div>
    </div>

    <div class="condition-group">
      <h5>Death (Select either Death or Related Death)</h5>
      <div class="conditions">
        <ion-item class="item ion-no-padding" *ngFor="let condition of conditions.death" lines="none">
          <ion-checkbox [(ngModel)]="condition.checked" (ionChange)="addCondition(condition, conditions)"
            [disabled]="condition.disabled && !condition.checked"></ion-checkbox>
          <ion-label>{{condition.group}}</ion-label>
        </ion-item>
      </div>
    </div>

  </ng-container>

  <ion-button type="text" (click)="reset()">
    Reset
    <ion-icon slot="end" name="refresh-outline"></ion-icon>
  </ion-button>
</div>
